(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("subscriptionCheckoutStep4Complete", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/checkout/subscriptionCheckoutStep4CompleteView.html",
            controller: ["subscriptionCheckoutService", "subscriptionResource", "messageService", "currencyService", "$translate", "$rootScope", "$state", SubscriptionCheckoutStep4CompleteCtrl],
            controllerAs: "vm"
        };
        function SubscriptionCheckoutStep4CompleteCtrl(subscriptionCheckoutService, subscriptionResource, messageService, currencyService, $translate, $rootScope, $state) {
            var vm = this;
            vm.showErrors = false;
            vm.loading = false;
            subscriptionCheckoutService.setStep(4);
            vm.orderId = $state.params.orderId;
            if (vm.orderId) {
                subscriptionResource.getSubscriptionCheckoutCompletionViewModel({ orderId: vm.orderId }, function (data) {
                    vm.order = data.details;
                    vm.currency = currencyService.find(vm.order.currencySymbol);
                    vm.order.currencySymbol = vm.currency.symbol_native;
                    vm.order.currencyName = $translate.instant("common.currency." + vm.currency.code);
                    if (vm.order.displayCurrency)
                        vm.order.dCurrencySymbol = currencyService.find(vm.order.displayCurrency).symbol;
                    vm.loading = false;
                    $rootScope.$broadcast("checkSubscription");
                }, function (error) {
                    messageService.error(error);
                });
            }
            else
                $state.go("main.settings.subscription");
            vm.print = function () {
                window.print();
            };
        }
    });
}());
